import React, { useEffect } from "react";

import Footer from "../components/Footer";
import Main from "../components/AboutUs/Main";
import Discover from "../components/AboutUs/Discover";
import OurWay from "../components/AboutUs/OurWay";
import YourMoneyCanWork from "../components/AboutUs/YourMoneyCanWork";
import YearHistory from "../components/AboutUs/YearHistory";
import OurAchievments from "../components/AboutUs/OurAchievments";

function AboutUs () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <Discover/>
            <OurWay/>
            <YourMoneyCanWork/>
            <YearHistory/>
            <OurAchievments/>
            <Footer titleKey="ambassador.23" />
        </div>
    );
}

export default AboutUs;